import { PlaylistAdd } from "@mui/icons-material";
import { Button } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { isMaxItemsReached } from "@ryde/shared";

import { CatchARideAvailabilityItemEdit } from "./catch-a-ride-availability-item.edit";
import {
  emptyCatchARideAvailability,
  ICatchARideAvailabilityItemForm,
} from "./catch-a-ride-availability.models";
import { useRestoreFocus } from "./use-restore-focus";

export const CatchARideAvailabilityItemAdd: FC<
  ICatchARideAvailabilityItemForm
> = ({
  index,
  setValueOuter,
  fieldName,
  formAttributes,
  onEditStart,
  onEditEnd,
}) => {
  const { t } = useTranslation();
  const [isAddNewOpened, setAddNewOpenedState] = useState(false);
  const addButtonRef = useRestoreFocus<HTMLButtonElement>(isAddNewOpened);
  const hideAppendButton = isMaxItemsReached(
    formAttributes?.maxItemsToAdd,
    index || 0,
  );

  useEffect(() => {
    if (isAddNewOpened) {
      onEditStart?.();
    } else {
      onEditEnd?.();
    }
  }, [isAddNewOpened, onEditStart, onEditEnd]);

  return (
    <>
      {isAddNewOpened && (
        <CatchARideAvailabilityItemEdit
          fieldName={`${fieldName}[${index || 0}]`}
          setValueOuter={setValueOuter}
          value={emptyCatchARideAvailability}
          index={index}
          formAttributes={formAttributes}
          onCancelOuter={() => setAddNewOpenedState(false)}
        />
      )}
      {!isAddNewOpened && !hideAppendButton && (
        <Button
          ref={addButtonRef}
          type="button"
          size="medium"
          className="add_button"
          startIcon={<PlaylistAdd />}
          onClick={() => setAddNewOpenedState(true)}
        >
          {t("general.APPEND")}
        </Button>
      )}
    </>
  );
};
